<template>
  <div id="app">
    <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate" v-if="!user"></md-progress-spinner>
    <router-view></router-view>
    <md-snackbar
      md-position="left"
      :md-duration="3000"
      :md-active.sync="displayNotification"
      md-persistent
    >
      <span>{{ this.notificationMessage }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      displayNotification: false
    };
  },
  computed: {
    ...mapState({
      user: s => s.auth.user,
      loading: s => s.auth.loading,
      showNotification: s => s.notification.showNotification,
      notificationMessage: s => s.notification.notificationMessage
    })
  },
  created() {},
  watch: {
    user: function(newUser) {},
    showNotification: function(notify) {
      this.displayNotification = true;
    }
  },
  methods: {
    ...mapActions(["fetchUser"])
  },
  mounted: function() {
    var that = this;
    this.fetchUser().then(function(user) {
      if (user && user.roles.includes('admin')) {
        that.$router.push("/admin/series");
      } else if (user && user.sub) {
        that.$router.push("/member/inbox");
      }
    });
  }
};
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
